import { copyOf, fmtCopy } from '../../../constants/copy-deck.prod-fixes';

/**
 * FIX-8 copy (UX-SPEC.md prod-fixes 2026-10-02 section 13, X8-1..X8-10), read from T1's ONE copy source,
 * `constants/copy-deck.prod-fixes.ts` (PLAN.md C8). This was T10's stand-in table until T1 merged
 * (integration round 2); the call sites keep `rerunCopy(id, params)`.
 */
export type RerunCopyId = 'X8-1' | 'X8-2' | 'X8-3' | 'X8-4' | 'X8-5' | 'X8-6' | 'X8-7' | 'X8-8' | 'X8-9' | 'X8-10';

/** The string for `id`, with `{name}` placeholders filled from `params`. */
export function rerunCopy(id: RerunCopyId, params: Record<string, string | number> = {}): string {
    return fmtCopy(copyOf(id), params);
}
